
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/promotion-detail",
      function () {
        return require("private-next-pages/promotion-detail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/promotion-detail"])
      });
    }
  